import ChatSettings from 'app/components/call/CallSettingsModal/ChatSettings';
import MediaSettings from 'app/components/call/CallSettingsModal/MediaSettings';
import { BookingStateConsumer } from 'app/containers/rtc/BookingContext/BookingState';
import { BookingTypeSettings } from 'app/models/rtc/booking/constants';
import React, { Fragment } from 'react';

interface IDeps {
  showChatSettings: boolean;
}

const CallSettings: React.FunctionComponent<IDeps> = ({ showChatSettings }) =>
  <Fragment>
    <MediaSettings />
    {showChatSettings && <ChatSettings />}
  </Fragment>;

const CallSettingsInjectDependencies = () => (
  <BookingStateConsumer>{(bookingState) =>
    <CallSettings
      showChatSettings={Boolean(
        bookingState &&
        BookingTypeSettings[bookingState.bookingType].showChatSettings,
      )}
    />
  }</BookingStateConsumer>
);

export default CallSettingsInjectDependencies;
